import { render } from "./AiconeLogo.vue?vue&type=template&id=b8c3ce8e&scoped=true"
import script from "./AiconeLogo.vue?vue&type=script&lang=js"
export * from "./AiconeLogo.vue?vue&type=script&lang=js"

import "./AiconeLogo.vue?vue&type=style&index=0&id=b8c3ce8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c3ce8e"]])

export default __exports__